// extracted by mini-css-extract-plugin
export default {"introContainer":"IntroStorePage_introContainer__ghqzY","cardPresentation":"IntroStorePage_cardPresentation__Be+r-","cardInfo":"IntroStorePage_cardInfo__ULomP"};